//react
import { useEffect, useState } from "react";

//kendo
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { alertLogDetail } from "./alertLogDetail";
import kendo from "@progress/kendo-ui";
import { IntlProvider, LocalizationProvider, loadMessages } from "@progress/kendo-react-intl";
import { Input } from "@progress/kendo-react-inputs";
import { filterBy } from "@progress/kendo-data-query";

//component
import DatePickerKo from "../../com/dateInputs/datePickerKo";
import { Create, Delete, Save } from "@material-ui/icons";
import { parseDate } from "../../../com/dateUtil";
import GridColumnInputFilter from "../../com/gridFilter/gridColumnInputFilter";
import GridInputCell from "../../com/gridFilter/gridInputCell";
import { BeatLoader } from "react-spinners";

//css
import "./alertLog.css";

//service
import { getAlertList, getExcelDownload, setUpdateAlert } from "../../../service/log/alertLogService";
import { getUserListData } from "../../../service/log/elderLogService";
import { useLocation } from "react-router-dom";
import { getUser, isAdmin, isDeveloper } from "../../../service/authService";
import { getRgns, getDongs } from './../../../service/areaService';
import { getUsers } from '../../../service/monitor/allStatusService';
import { downloadExcel } from "../../../com/downloadExcel";

const AlertLog = ({ conn, dongList, codeList }) => {
  /* -------------------------------------------------------------- useState 및 변수  */
  const [loading, setLoading] = useState(false);
  const locationState = useLocation().state;
  const userInfo = getUser();
  const [dataSource, setDataSource] = useState({
    results: [],
    total: 0,
    rgnList: [], 
    dongList: [],
    userList: [],
  });
  const [dataState, setDataState] = useState({
    take: 15,
    skip: 0,
    sort: [],
    sortStatus: [],
    startDtm: new Date(),
    endDtm: new Date(),
    eventType: "",
    // userId: "",
    // userTerm: "",
    // rgnCode: getUser().rgnCode,
    // dongCode: "",
    // 드롭다운 시군구 표출 값
    rgnCode: userInfo.rgnCode,
    rgnTermSimple: null,
    rgns : { rgnTermSimple: "시/군/구", rgnCode: "" },
    // 드롭다운 읍면동 표출 값
    dongCode: userInfo.dongCode,
    dongTermSimple: null,
    dongs : { dongTermSimple: "읍/면/동", dongCode: "" },
    // 드롭다운 유저 표출 값
    userId: '',
    userTerm: '',
    users : { userTerm: "대상자 선택", userId: "" },
  });
  const [evtTypeList, setEvtTypeList] = useState([]);
  // 유저 정보 리스트 데이터 소스
  const [userList, setUserList] = useState({
    all: [],
    filtered: [],
  });
  // 유저 드롭다운 박스
  const [user, setUser] = useState({ userTerm: "대상자 선택", userId: "" });
  const [dong, setDong] = useState({ dongTermSimple: "전체", dongCode: "" });
  const [evt, setEvt] = useState({ codeVal: "전체", codeNo: "" });

  const defualtValRgn = { rgnTermSimple: "시/군/구", rgnCode: "" };
  const defualtValDong = { dongTermSimple: "읍/면/동", dongCode: "" };
  const defaultValUser = { userTerm: "대상자 선택", userId: "" };

  /* -------------------------------------------------------------- service 및 데이터 조회  */
  //알림이력 그리드 데이터 불러오기
  const getGridData = () => {
    setLoading(true);
    getAlertList(conn, dataState)
      .then(response => {
        // setDataSource(response);
        setDataSource((dataSource) => {
          const item = { ...dataSource };
          item.results = response.results;
          item.total = response.total;
          return item;
        })
        setLoading(false);
      })
      .catch(error => {
        console.log("getAlertList Error", error);
      });
    // setDataSource(getAlertList(conn, dataState));
  };
  // 유저 목록 불러오기
  const getUserList = () => {
    getUserListData(conn, dataState, getUserListCallback, getUserListRejection);
  };
  // 유저 목록 callback
  const getUserListCallback = result => {
    if (locationState) {
      const locationElder = result.filter(item => item.userTerm === locationState.elderTerm);
      setUser(locationElder.length ? locationElder[0] : { userTerm: "대상자 선택", userId: "" });
      setDong({ dongCode: locationState.dongCode, dongTermSimple: locationState.dongTermSimple });
      setEvt({ codeVal: locationState.eventTypeTerm ? locationState.eventTypeTerm : "전체", codeNo: locationState.eventType });
      const filteredUserList = result.filter(item => item.dongCode === locationState.dongCode);
      setUserList({ ...userList, all: result, filtered: filteredUserList });
      setData(filteredUserList)
    } else {
      setUserList({ ...userList, all: result });
      setData(result)
    }
  };
  // 유저 목록 rejection
  const getUserListRejection = error => {};

  /* -------------------------------------------------------------- changeEvent clickEvent  */
  // 그리드 페이징 처리
  const handlePageChange = e => {
    const { take, skip } = e.page;
    dataState.skip = skip;
    dataState.take = take;
    getGridData();
  };

  /* 디테일 뷰 보기 */
  const expandChange = event => {
    let newData = dataSource.results.map(item => {
      if (item.alarmNo === event.dataItem.alarmNo) {
        item.expanded = !event.dataItem.expanded;
      }

      return item;
    });
    setDataSource({ ...dataSource, results: newData });
  };

  /* start 조회기간 변경이벤트 */
  const startDtmChngEvt = v => {
    setDataState({ ...dataState, startDtm: v });
  };

  /* end 조회기간 변경이벤트 */
  const endDtmChngEvt = v => {
    setDataState({ ...dataState, endDtm: v });
  };
  /* 돋보기 버튼 클릭이벤트 */
  const searchBtnClickEvt = () => {
    // 페이징
    dataState.skip = 0;
    dataState.take = 20;
    getGridData();
  };
  // 초기 데이터 가져오기
  const getDataList = () => {
    setLoading(true);
    // 시군구
    getRgns(conn)
    .then(response => {
      setDataState(dataState => {
        const item = { ...dataState };
        item.rgns = response.find(item => item.rgnCode === userInfo.rgnCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.rgnList = response
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getRgns error = ", error);
    });
    // 읍면동
    getDongs(conn, userInfo.rgnCode)
    .then(response => {
      setDataState(dataState => {
        const item = { ...dataState };
        item.dongs = response.find(item => item.dongCode === userInfo.dongCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.dongList = response;
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getDongs error = ", error);
    });
    // 대상자
    getUsers(conn, dataState)
    .then(response => {
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.userList = response.filter(item => item.meainStatCode !== "20005");
        // item.userList = response;
        return item;
      })
      setData(response.slice());
    })
    .catch(error => {
      console.log("getUserList error = ", error);
    })
  }

  /* -------------------------------------------------------------- changeEvent clickEvent  */
  // 시군구, 읍면동, 대상자 드롭다운 체인지 이벤트
  const changeDropEvent = e => {
    if (e.target.name === "rgn") {
      setDataState(dataState => {
        const item = { ...dataState };
        // 드롭다운 검색조건 변경
        item.rgnCode = e.target.value.rgnCode;
        item.rgns = e.target.value;
        // 하위 데이터 초기화
        item.dongs = { dongTermSimple: "읍/면/동", dongCode: "" };
        item.dongCode = "";
        item.users = { userTerm: "대상자 선택", userId: "" };;
        item.userId = "";
        item.userTerm = "";
        // 대상자 데이터 조회
        getUsers(conn, item)
        .then(response => {
          setDataSource(dataSource => {
            const item = { ...dataSource };
            item.userList = response.filter(item => item.meainStatCode !== "20005");
            // item.userList = response;
            return item;
          })
          setData(response.slice());
        })
        .catch(error => {
          console.log("getUserList error = ", error);
        })
        return item;
      })
      // 읍면동 데이터 조회
      getDongs(conn, e.value.rgnCode)
      .then(result => {
        setDataSource(dataSource => {
          const item = { ...dataSource };
          item.dongList = result;
          return item;
        })
      })
      .catch(error => {
        console.log("getDongs error = ", error);
      });

    } else if (e.target.name === "dong") {
      setDataState(dataState => {
        const item = { ...dataState };
        // 드롭다운 검색조건 변경
        item.dongCode = e.target.value.dongCode;
        item.dongs = e.target.value;
        // 하위 데이터 초기화
        item.users = { userTerm: "대상자 선택", userId: "" };;
        item.userId = "";
        item.userTerm = "";
        // 대상자 데이터 조회
        getUsers(conn, item)
        .then(response => {
          setDataSource(dataSource => {
            const item = { ...dataSource };
            item.userList = response.filter(item => item.meainStatCode !== "20005");
            // item.userList = response;
            return item;
          })
          setData(response.slice());
        })
        .catch(error => {
          console.log("getUserList error = ", error);
        })
        return item;
      })
    } else if (e.target.name === 'user') {
      // 드롭다운 검색조건 변경
      if(e.target.value.userTerm === "대상자 선택") {
        setDataState(dataState => {
          const item = { ...dataState };
          item.userId = e.target.value.userId;
          item.userTerm = "";
          item.users = e.target.value;
          return item;
        })
      } else {
        setDataState(dataState => {
          const item = { ...dataState };
          item.userId = e.target.value.userId;
          item.userTerm = e.target.value.userTerm;
          item.users = e.target.value;
          return item;
        })
      }
    }
  }
  /* 발생이벤트 드롭다운 변경 이벤트 */
  const evtTypeDdlChngEvt = e => {
    const { value } = e;
    setDataState({ ...dataState, eventType: value.codeNo });
    setEvt({ codeVal: value.codeVal, codeNo: value.codeNo });
  };

  /* 대상자 드롭다운리스트 오픈 이벤트 */
  const userDdlOpenEvt = () => {
    if (dongList.length) {
      if (getUser().userTypeCode === 2002) {
        const result = dongList.find(item => item.dongCode === getUser().dongCode);
        setDong(result);
        setDataState({ ...dataState, dongCode: getUser().dongCode });
        const filteredUserList = userList.all.filter(item => item.dongCode === getUser().dongCode);
        setUserList({ ...userList, filtered: filteredUserList });
      }
    }
  };

  /* --------------------------------------------------------------------- gridCell  */

  const dongTermCell = gridCellItem => {
    const { dataItem } = gridCellItem;

    return <td>{dataItem.dongTerm}</td>;
  };

  const elderTermCell = gridCellItem => {
    const { dataItem } = gridCellItem;
    const isDailyAlarm = dataItem.eventType === 11010;

    return <td>{isDailyAlarm ? "-" : dataItem.elderTerm}</td>;
  };

  /* 통화확인 셀 */
  const callYnCell = gridCellItem => {
    const { dataItem } = gridCellItem;
    const ddlData = ["Y", "N"];
    const isDailyAlarm = dataItem.eventType === 11010;

    const callYnDdlChngEVt = ddlItem => {
      const { value } = ddlItem;
      let temp = dataSource.results.slice();
      temp.forEach(data => {
        if (data.alarmNo === dataItem.alarmNo) {
          data.callYn = value;
        }
      });
      setDataSource({ ...dataSource, results: temp });
    };

    return (
      <td>
        {isDailyAlarm ? (
          "-"
        ) : (
          <DropDownList className="gridCellWidth" data={ddlData} value={dataItem.callYn} onChange={callYnDdlChngEVt}></DropDownList>
        )}
      </td>
    );
  };

  /* 방문확인 셀 */
  const visitYnCell = gridCellItem => {
    const { dataItem } = gridCellItem;
    const ddlData = ["Y", "N"];
    const isDailyAlarm = dataItem.eventType === 11010;

    const visitYnDdlChngEVt = ddlItem => {
      const { value } = ddlItem;
      let temp = dataSource.results.slice();
      temp.forEach(data => {
        if (data.alarmNo === dataItem.alarmNo) {
          data.visitYn = value;
        }
      });
      setDataSource({ ...dataSource, results: temp });
    };
    return (
      <td>
        {isDailyAlarm ? (
          "-"
        ) : (
          <DropDownList className="gridCellWidth" data={ddlData} value={dataItem.visitYn} onChange={visitYnDdlChngEVt}></DropDownList>
        )}
      </td>
    );
  };

  /* 방문확인 셀 */
  const checkDtmCell = gridCellItem => {
    const { dataItem } = gridCellItem;
    let isDisabled = true;
    const isDailyAlarm = dataItem.eventType === 11010;
    if (dataItem.visitYn === "Y" || dataItem.callYn === "Y") isDisabled = false;

    const gridConfirmBtnClickEvt = () => {
      let temp = dataSource.results.slice();
      temp.forEach(data => {
        if (data.alarmNo === dataItem.alarmNo) {
          data.checkDtm = parseDate("yyyy-mm-dd hh:mm:ss", new Date());
        }
      });
      setDataSource({ ...dataSource, results: temp });
    };

    return (
      <td>
        {isDailyAlarm ? (
          "-"
        ) : dataItem.checkDtm === null ? (
          <Button disabled={isDisabled} onClick={gridConfirmBtnClickEvt}>
            정상전환
          </Button>
        ) : (
          <>{dataItem.checkDtm}</>
        )}
      </td>
    );
  };

  /* 저장 셀 */
  const gridSaveCell = e => {
    const { dataItem } = e;
    const isDailyAlarm = dataItem.eventType === 11010;
    const gridSaveBtnClickEvt = () => {
      kendo.confirm("저장하시겠습니까?").then(() => {
        if ((dataItem.callYn === "Y" || dataItem.visitYn === "Y") && !dataItem.checkDtm) {
          kendo.alert("대상자 확인이 되었으면 정상전환 버튼을 눌러주시기 바랍니다.");
          return;
        }
        dataItem.checkId = userInfo.userId;
        dataItem.checkTerm = userInfo.userTerm;
        setUpdateAlert(conn, dataItem)
          .then(() => {
            kendo.alert("저장 완료");
            getGridData();
          })
          .catch(error => {
            kendo.alert("저장 실패");
            console.log("setUpdateAlert Error", error);
            getGridData();
          });
      });
    };
    return <td>{isDailyAlarm ? "-" : <Save className="saveBtn" onClick={gridSaveBtnClickEvt}></Save>}</td>;
  };

  // 확인자
  const checkCell = e => {
    const { dataItem } = e;
    let result = "";
    result = (dataItem.checkTerm ? dataItem.checkTerm : "-") + (dataItem.checkId ? "(" + dataItem.checkId + ")" : "");
    // 조치자 번호까지 추가 했을 경우
    // result = (dataItem.checkTerm ? dataItem.checkTerm : "-") + (dataItem.checkId ? "(" + dataItem.checkId + ")" : "") + " / " + (dataItem.checkPhone ? dataItem.checkPhone : "-") ;
    return <td>{result}</td>
  }

  //수신인 / 수신번호 셀
  const receiveCell = e => {
    const { dataItem } = e;
    const isDailyAlarm = dataItem.eventType === 11010;
    let result = "";
    if (dataItem) {
      if (dataItem.eventType === 11010) {
        result = "-";
      } else {
        result = (dataItem.receiveTerm ? dataItem.receiveTerm : "-") + " / " + (dataItem.receivePhone ? dataItem.receivePhone : "-");
      }
    }
    return <td>{result}</td>;
  };
  /* -------------------------------------------------------------- custom 함수  */
  // 엑셀 다운로드 이벤트
  const excelDown = () => {
    setLoading(true);
    getExcelDownload(dataState, setLoading);
  };

  /* -------------------------------------------------------------- useEffect  */

  useEffect(() => {
    getDataList();
  }, []);

  useEffect(() => {
    const currentDate = new Date(); // Current date and time
    const oneWeekAgo = new Date(); // Date object for one week ago
    oneWeekAgo.setDate(currentDate.getDate() - 7);
    // dataState.userTerm = locationState ? locationState.elderTerm : "";
    // dataState.userId = locationState ? locationState.elderId : "";
    // dataState.dongCode = locationState ? locationState.dongCode : "";
    dataState.users = locationState ? { userTerm: locationState.elderTerm, userId: locationState.elderId } : { userTerm: "대상자 선택", userId: "" };
    dataState.userId = locationState ? locationState.elderId : "";
    dataState.userTerm = locationState ? locationState.elderTerm : "";
    
    dataState.startDtm = locationState ? new Date(locationState.startDtm) : oneWeekAgo;
    dataState.endDtm = locationState ? new Date(locationState.endDtm) : new Date();
    getGridData();
    // getUserList();
  }, [locationState]);

  useEffect(() => {
    const temp = codeList.filter(item => item.grpCodeNo === 11 && item.codeNo !== 11002);
    temp.unshift({ codeVal: "전체", codeNo: "" });
    setEvtTypeList(temp);
  }, [codeList]);


  const [data, setData] = useState(dataSource.userList.slice());
  const filterData = (filter) => {
    const data = dataSource.userList.slice();
    return filterBy(data, filter);
  };
  const filterChange = (event) => {
    setData(filterData(event.filter));
  };

  /* -------------------------------------------------------------- return  */
  return (
    <div>
      <div className="alertLogSearch">
        <span className="alertLogSearchFirst">
        <span className="alertLogSearchSpan">시군구</span>
          <DropDownList
            id="rgn"
            name="rgn"
            data={dataSource.rgnList}
            disabled={!isDeveloper() ? true : false}
            className="searchDong"
            value={dataState.rgns}
            textField="rgnTermSimple"
            dataItemKey="rgnCode"
            defaultItem={defualtValRgn}
            onChange={changeDropEvent}
          />
          <span className="alertLogSearchSpan">읍면동</span>
          <DropDownList
            id="dong"
            name="dong"
            data={dataSource.dongList}
            disabled={!isAdmin() ? true : !dataState.rgnCode ? true : false}
            className="searchDong"
            value={dataState.dongs}
            textField="dongTermSimple"
            dataItemKey="dongCode"
            defaultItem={defualtValDong}
            onChange={changeDropEvent}
          />
          <span className="alertLogSearchSpan">대상자</span>
          <DropDownList
            id="user"
            name="user"
            data={data}
            className="searchUser"
            value={dataState.users}
            textField="userTerm"
            dataItemKey="userId"
            defaultItem={defaultValUser}
            onChange={changeDropEvent}
            filterable
            onFilterChange={filterChange}
          />
          {/* <span className="alertLogSearchSpan">읍면동</span>
          <DropDownList
            data={dongList}
            defaultItem={{ dongTermSimple: "전체", dongCode: "" }}
            disabled={getUser().userTypeCode === 2002}
            name="dong"
            textField="dongTermSimple"
            dataItemKey="dongCode"
            onChange={changeDropEvt}
            className="searchDong"
            value={dong}
          />
          <span className="alertLogSearchSpan">대상자</span>
          <DropDownList
            data={data}
            defaultItem={{ userTerm: "대상자 선택", userId: "" }}
            name="user"
            textField="userTerm"
            dataItemKey="userId"
            onChange={changeDropEvt}
            // onOpen={userDdlOpenEvt}
            filterable={true}
            onFilterChange={filterChange}
            className="searchUser"
            value={user}
          /> */}
          <span className="alertLogSearchSpan">발생이벤트</span>
          <DropDownList
            data={evtTypeList}
            textField="codeVal"
            key="codeNo"
            defaultValue={evtTypeList.length ? evtTypeList[0] : { codeVal: "전체", codeNo: "" }}
            onChange={evtTypeDdlChngEvt}
            value={evt}
          />
        </span>
        <span className="alertLogSearchSecond">
          <span className="alertLogSearchSpan">조회기간</span>
          <DatePickerKo value={dataState.startDtm} max={dataState.endDtm} setDtm={startDtmChngEvt}></DatePickerKo> ~{" "}
          <DatePickerKo value={dataState.endDtm} min={dataState.startDtm} max={new Date()} setDtm={endDtmChngEvt}></DatePickerKo>
          <Button icon="search" className="alertLogSearchBtn" onClick={searchBtnClickEvt}></Button>
          <Button className="alertLogExcelBtn" onClick={excelDown}><span role="presentation" class="k-icon k-i-excel"></span>엑셀저장</Button>
        </span>
      </div>
      <div
        className="alertLogContent"
        style={
          loading
          ? {
            opacity: 0.6,
            pointerEvents: "none",
            position: "relative",
          }
          : null
        }>
        <LocalizationProvider language="ko-KR">
          <IntlProvider locale="ko">
            <Grid
              className="alertLogGrid"
              style={{ height: "100%" }}
              data={dataSource.results}
              detail={alertLogDetail}
              expandField="expanded"
              onPageChange={handlePageChange}
              onExpandChange={expandChange}
              onRowClick={expandChange}
              skip={dataState.skip}
              take={dataState.take}
              total={dataSource.total}
              pageable={{
                type: "numeric",
                pageSizes: [5, 10, 15, 20, 50],
                previousNext: true,
                buttonCount: 5,
              }}>
              <GridColumn field="ocurDtm" title="발생시간" width="160" />
              <GridColumn field="eventTypeTerm" title="발생이벤트" width="110" />
              <GridColumn field="dongTerm" cell={dongTermCell} title="지역(읍/면/동)" width="110" />
              <GridColumn field="elderTerm" cell={elderTermCell} title="대상자" width="110" />
              <GridColumn field="callYn" cell={callYnCell} title="통화확인" width="120" />
              <GridColumn field="visitYn" cell={visitYnCell} title="방문확인" width="120" />
              <GridColumn field="checkDtm" cell={checkDtmCell} title="확인시간" width="180" />
              <GridColumn field="checkTerm" cell={checkCell} title="조치자" width="200" />
              {/* <GridColumn field="receiveTerm" cell={receiveCell} title="수신인/수신번호" width="230"/> */}
              <GridColumn field="processingContent" cell={GridInputCell} title="조치내용" />
              <GridColumn field="aicallContent" title="AI CALL 대화내용" />
              <GridColumn title="저장" width="80px" cell={gridSaveCell} />
              <GridNoRecords>데이터가 존재하지 않습니다.</GridNoRecords>
            </Grid>
            {loading && (
              <p
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                }}>
                <BeatLoader loading={true} size={24} color="#1e88e5" />
              </p>
            )}
          </IntlProvider>
        </LocalizationProvider>
      </div>
    </div>
  );
};
export default AlertLog;
